import React from 'react';
import {
  AdultIcon,
  BabyIcon,
  KidsIcon,
  MatureIcon,
  OldIcon,
  TeenIcon,
} from '../icons';

export const ICON_LABEL = [
  {
    key: 'age0',
    label: 'Baby',
    desc: '0-4',
    icon: <BabyIcon />,
  },
  {
    key: 'age5',
    label: 'Kids',
    desc: '5-9',
    icon: <KidsIcon />,
  },
  {
    key: 'age10',
    label: 'Teen',
    desc: '10-14',
    icon: <TeenIcon />,
  },
  {
    key: 'age15',
    label: 'Teen',
    desc: '15-19',
    icon: <TeenIcon />,
  },
  {
    key: 'age20',
    label: 'Adult',
    desc: '20-24',
    icon: <AdultIcon />,
  },
  {
    key: 'age25',
    label: 'Adult',
    desc: '25-29',
    icon: <AdultIcon />,
  },
  {
    key: 'age30',
    label: 'Adult',
    desc: '30-34',
    icon: <MatureIcon />,
  },
  {
    key: 'age35',
    label: 'Adult',
    desc: '35-39',
    icon: <MatureIcon />,
  },
  {
    key: 'age40',
    label: 'Mature',
    desc: '40-44',
    icon: <OldIcon />,
  },
  {
    key: 'age45',
    label: 'Mature',
    desc: '45-49',
    icon: <OldIcon />,
  },
  {
    key: 'age50',
    label: 'Mature',
    desc: '50-54',
    icon: <OldIcon />,
  },
  {
    key: 'age55',
    label: 'Mature',
    desc: '55-59',
    icon: <OldIcon />,
  },
  {
    key: 'age60',
    label: 'Mature',
    desc: '60-64',
    icon: <OldIcon />,
  },
  {
    key: 'age65',
    label: 'Mature',
    desc: '65-UP',
    icon: <OldIcon />,
  },
];
